import 'bootstrap/dist/css/bootstrap.min.css';

const footerStyle = {
  background: 'rgba(0, 0, 0, 0.4)',
  color: 'rgba(255, 255, 255, 0.9)',
  backdropFilter: 'blur(6px)',
  textAlign: 'center',
  padding: '1rem 0',
};

const taglineStyle = {
  color: 'rgba(255, 255, 255, 0.7)',
};

function Footer() {
  return (
    <footer style={footerStyle}>
      <div className='container'>
        <p className='mb-1'>
          &copy; {new Date().getFullYear()}{' '}
          <strong>Pravin Birdnetting Service</strong>. All rights reserved.
        </p>
        <small style={taglineStyle}>
          Professional Bird Netting Services in Pune
        </small>{' '}
        <br />
        <small style={taglineStyle}>Develop by:Yogesh Jamnor</small>
      </div>
    </footer>
  );
}

export default Footer;
